<template>
  <div id="q-app">
    <!-- style="background-color:#edffea"-->
    <transition-group appear leave-active-class="animated fadeOut">
      <div
        key="div2"
        v-if="fullLoading"
        class="loaderOverlay"
        style="display: flex; align-items: center; justify-content: center"
      >
        <img
          src="/statics/Oatas Hero Logo-03.svg"
          alt="Oatas Hero Logo"
          style="width: 300px; height: 150px"
        />
      </div>
    </transition-group>

    <popout />

    <q-layout view="hHh lpR fFf">
      <app-bar v-if="!$route.meta.fullscreen" />
      <q-page-container>
        <q-scroll-area
          :thumb-style="{
            background: '#162c479c',
            opacity: 1,
            width: '8px',
            height: '8px',
            borderRadius: '20px',
          }"
          :style="`height: calc(100vh - ${
            $route.meta.fullscreen != true ? '60px' : '0px'
          })`"
        >
          <router-view
            :class="{
              'q-pa-sm':
                !$route.meta.fullscreen &&
                this.$q.screen.lt.sm &&
                routeNamesWithNoPadding.includes($route.name),
              'q-pa-md':
                !$route.meta.fullscreen &&
                this.$q.screen.gt.sm &&
                routeNamesWithNoPadding.includes($route.name),
            }"
          />
        </q-scroll-area>
      </q-page-container>
    </q-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppBar from "@/components/AppBar";
import popout from "@/components/popoutTabs/popout.vue";

export default {
  components: {
    AppBar,
    popout,
  },
  computed: {
    ...mapGetters({
      fullLoading: "settings/fullLoading",
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      offlineMode: "settings/offlineMode",
      outcomesList: "outcomes/list",
    }),
  },
  data: () => ({
    routeNamesWithNoPadding: ["worskpace", "outcomeSelection"],
  }),
  watch: {
    currentUser: function (oldData, newData) {
      this.checkLoggedIn();
    },

    $route: function (newRoute, oldRoute) {
      this.checkLoggedIn();

      this.initOutcome();
    },
    currentUserData: function () {
      // if (
      //   this.$router.path != "/wizard" &&
      //   this.currentUserData.hasOwnProperty("role") &&
      //   this.currentUserData.sustainabilityQuestionnaireRequired == 1
      // ) {
      //   this.$router.push("/questionnaire");
      // }
      this.checkUserData();
    },
  },
  mounted() {
    this.checkLoggedIn();
    this.checkUserData();
    this.initOutcome();
  },
  methods: {
    checkLoggedIn() {
      // var ts = Math.round(new Date().getTime() / 1000);
      if (this.currentUser != null && this.currentUser != "loading") {
        if (this.$route.path === "/login") {
          this.$router.push("/");
        }
      } else if (this.currentUser != "loading") {
        if (this.$route.path != "/login") {
          this.$router.push("/login");
        }
      }
    },
    checkUserData() {
      if (
        this.currentUserData &&
        this.currentUserData.role.includes("SustainabilityBusiness")
      ) {
        this.$store.dispatch("business/loadAuthenticated");
        this.$store.dispatch("businessExtra/load");
      }
    },
    async initOutcome() {
      if (this.$route.params.outcomesID) {
        if (this.outcomesList.length < 1) {
          await this.$store.dispatch("outcomes/loadAll");
        }
        let outcome = this.outcomesList.find(
          (e) => e.id == this.$route.params.outcomesID
        );

        // If outcome found then set the selected outcome, otherwise go to Outcome Selection
        if (outcome) {
          this.$store.dispatch("general/updateSelectedOutcome", outcome);
          this.$store.dispatch("businessTargets/loadAll", {
            outcomes_id: outcome.id,
          });
        }
      } else {
        this.$store.dispatch("general/updateSelectedOutcome", null);
      }
    },
  },
};
</script>

<style lang="scss">
// @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:wght@300&display=swap");

.ProseMirror:focus {
  outline: none;
}

.highlight {
  font-weight: 800;
  color: var(--outcome-secondary);
}

.highlightPrimary {
  font-weight: 800;
  color: var(--outcome-primary);
}

.swal2-container {
  z-index: 10060 !important;
}

body {
  scrollbar-color: #162c479c rgba(255, 255, 255, 0.055);
  scrollbar-width: thin;
}

::-webkit-scrollbar {
  width: 8px !important;
  height: 8px;
}
::-webkit-scrollbar-track {
  // background: $scrollbarTrack;
  background: rgba(255, 255, 255, 0.055);
}
::-webkit-scrollbar-thumb {
  background: #162c479c;
  border-radius: 20px !important;
}
::-webkit-scrollbar-thumb:hover {
  background: $scrollbarHover;
}
.loaderOverlay {
  z-index: 9999;
  background: $accent2;
  width: 100vw;
  height: 100vh;
  position: fixed;
}
.lds-ripple {
  top: calc(50vh - 40px);
  left: calc(50vw - 40px);
  display: inline-block;
  position: fixed;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid $primary;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

.q-scrollarea__content {
  width: 100% !important;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.sustainability-card-radius {
  border-radius: 10px !important;
}
</style>
